import { find, get } from "lodash";
import { useState } from "react";
import Loading from "shared/components/Spin";
import { useQuery } from "shared/hooks/useApi";
import { COVERAGE_CATEGORIES } from "utils/api/graphql/queries/coverage-categories";
import { PROCESS } from "utils/api/graphql/queries/processes";
import { PROCESS_CONFIG_TYPES } from "utils/constants";
import View from "./View";

const CollectionNeeds = ({ project, onNext, tracer, onBack }) => {
  const [nextLoading, setNextLoading] = useState(false);
  const { data: processData, loading: processLoading } = useQuery(PROCESS, {
    variables: { where: { id: get(tracer, "flow.process.id") } },
  });
  const next = (fields) => {
    setNextLoading(true);
    onNext({
      payload: {
        fields,
      },
      onCompleted: () => setNextLoading(false),
      onError: () => setNextLoading(false),
    });
  };
  const { data } = useQuery(COVERAGE_CATEGORIES, {
    variables: { gt: { weight: 0, order: 0 } },
  });
  if (processLoading) return <Loading />;
  return (
    <View
      data={get(data, "coverageCategories.data") || []}
      next={next}
      project={project}
      onBack={onBack}
      nextLoading={nextLoading}
      config={find(
        get(processData, "process.config", []),
        ({ type }) => type === PROCESS_CONFIG_TYPES.NEEDS,
      )}
    />
  );
};

export default CollectionNeeds;
